import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { environment } from '@environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';

const CHATBOT_TAG = 'mini-chatbot';
const TOGGLE_BUTTON_STYLE = '.chatbot-toggle-btn { width: 70px; height: 70px; }';

interface MiniChatbotElement extends HTMLElement {
  token?: string;
  environnement?: string;
}

/**
 * Chatbot: hosts the `<mini-chatbot>` web component loaded by the Alfred CDN script
 * injected from `main.ts` when enabled for the current environment.
 *
 */
@Component({
  selector: 'tmn-chatbot',
  standalone: true,
  templateUrl: './chatbot.component.html',
  styleUrl: './chatbot.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatbotComponent implements AfterViewInit, OnDestroy {
  @ViewChild('host', { read: ElementRef, static: true })
  private host!: ElementRef<HTMLElement>;

  private chatbotElement: MiniChatbotElement | null = null;

  readonly environnement: string = environment.production ? 'production' : 'staging'; // MTA requires 'production' or 'staging' as environment value

  constructor(private readonly oauthService: OAuthService) {}

  ngAfterViewInit(): void {
    const token = this.oauthService.getIdToken() || '';
    this.chatbotElement = document.createElement(CHATBOT_TAG) as MiniChatbotElement;
    this.chatbotElement.setAttribute('environnement', this.environnement);
    this.chatbotElement.setAttribute('token', token);
    this.host.nativeElement.appendChild(this.chatbotElement);
    this.injectShadowStyles(this.chatbotElement);
  }

  ngOnDestroy(): void {
    this.chatbotElement?.remove();
    this.chatbotElement = null;
  }

  private injectShadowStyles(host: MiniChatbotElement): void {
    const shadow = host.shadowRoot;
    if (!shadow) {
      return;
    }
    const style = document.createElement('style');
    style.textContent = TOGGLE_BUTTON_STYLE;
    shadow.appendChild(style);
  }
}
